<template>
  <main-layout
    class="damage"
    page-title="农机订单详情"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content" v-loading="loading">
      <div class="common">
        <div class="header">订单信息</div>
        <div class="content">
          <div class="li-item">
            <span>订单编号：</span>
            <span>{{ baseInfo.orderNo }}</span>
          </div>
          <div class="li-item">
            <span>订单状态：</span>
            <span
              :style="{
                color:
                  dealStataus(baseInfo.status) &&
                  dealStataus(baseInfo.status).color,
              }"
              >{{
                dealStataus(baseInfo.status) &&
                dealStataus(baseInfo.status).label
              }}</span
            >
          </div>
          <div class="li-item">
            <span>联系电话：</span>
            <span>{{ baseInfo.phone }}</span>
          </div>
          <div class="li-item">
            <span>作业类型：</span>
            <span>{{ baseInfo.workTypeName }}</span>
          </div>
          <div class="li-item">
            <span>下单时间：</span>
            <span> {{ baseInfo.createTime | orderFormTime_filter }} </span>
          </div>
          <div class="li-item">
            <span>期望作业时间：</span>
            <span
              >{{ baseInfo.expectBeginTime }}
              至
              {{ baseInfo.expectEndTime }}</span
            >
          </div>
          <div class="li-item">
            <span>作物：</span>
            <span>{{ baseInfo.cropGroupName }}</span>
          </div>
          <div class="li-item">
            <span>意向农机手：</span>
            <span> {{ manipulatorList.join("、") || "--" }}</span>
          </div>
          <div class="li-item">
            <span>作业面积：</span>
            <span>{{ baseInfo.orderArea }}亩</span>
          </div>
          <div class="li-item">
            <span>备注：</span>
            <span>{{ baseInfo.remark || "--" }}</span>
          </div>
          <div class="map">
            <choose-land mode="show" :query="{ orderId }"></choose-land>
          </div>
        </div>
      </div>
      <div class="common" v-if="scoreInfo.id">
        <div class="header">评价信息</div>
        <div class="content">
          <div class="li-item spic-item">
            <span>整体满意度：</span>
            <el-rate class="rate" v-model="scoreInfo.score" disabled> </el-rate>
          </div>
          <div class="li-item">
            <span>评价时间：</span>
            <span>{{ scoreInfo.createTime | orderFormTime_filter }}</span>
          </div>
          <div class="li-item">
            <span>备注：</span>
            <span>{{ scoreInfo.remark || "--" }}</span>
          </div>
          <div class="imgs" v-if="scoreInfo.imageUrl">
            <div
              class="img-li"
              v-for="(item, idx) in scoreInfo.imageUrl.split(',')"
              :key="idx"
            >
              <el-image
                class="img"
                :src="setImgUrl(item, 100, 100)"
                :initial-index="idx"
                :preview-src-list="scoreInfo.imageUrl.split(',')"
              >
              </el-image>
            </div>
          </div>
          <!-- 农机手评价 -->
          <div
            class="njs-content"
            :class="{ notimg: !value.imageUrl }"
            v-for="(value, index) in scoreInfo.manipulatorScoreVoList"
            :key="index"
          >
            <div class="njs-item spic-item">
              <span> 农机手: </span>
              <span class="label">{{ value.manipulatorName }}</span>
              <el-rate class="rate" v-model="value.score" disabled> </el-rate>
            </div>
            <div class="njs-item">
              <span>备注：</span>
              <span>{{ value.remark || "--" }}</span>
            </div>
            <div class="imgs" v-if="value.imageUrl">
              <div
                class="img-li"
                v-for="(item, index) in value.imageUrl.split(',')"
                :key="index"
              >
                <el-image
                  class="img"
                  :src="setImgUrl(item, 100, 100)"
                  :initial-index="index"
                  :preview-src-list="value.imageUrl.split(',')"
                >
                </el-image>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="common" v-if="list.length || tableLoading">
        <div class="header spic">农机作业任务</div>
        <el-table
          class="table"
          ref="multipleTable"
          empty-text="暂无作业任务"
          :data="list"
          :header-cell-style="{ color: '#64C3A4', fontSize: '16px' }"
          :cell-style="{ color: '#666666' }"
          stripe
          height="330"
        >
          <el-table-column label="农机手" prop="manipulatorName" />
          <el-table-column label="作业面积（亩）" prop="missionArea" />
          <el-table-column
            label="预计作业日期"
            prop="sendBeginDate"
            width="240"
          >
            <template slot-scope="{ row }">
              <span
                >{{ row.sendBeginDate | orderFormTime_filter("yyyy-MM-dd") }} 至
                {{ row.sendEndDate | orderFormTime_filter("yyyy-MM-dd") }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="status">
            <template slot-scope="{ row }">
              <span>{{
                ["已拒单", "待确认", "待作业", "作业中", "已完成"][
                  row.status + 2
                ]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际开始时间" prop="beginTime">
            <template slot-scope="{ row }">
              <span>{{
                row.beginTime | orderFormTime_filter("yyyy-MM-dd hh:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际完成时间" prop="endTime">
            <template slot-scope="{ row }">
              <span>{{
                row.endTime | orderFormTime_filter("yyyy-MM-dd hh:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="农机信息" prop="machineryTypeName">
            <template slot-scope="{ row }">
              <span>
                {{ row.machineryTypeName
                }}{{ row.plateNumber | plateNumber_filter }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagiation
          :total="total"
          :pageSize="formInline.pageSize"
          :pageNo="formInline.pageNo"
          @currentChange="currentChange"
          :pagisShow="pagisShow"
        />
      </div>
    </div>
  </main-layout>
</template>
<script>
import MainLayout from "@/layout/MainLayout";
import Pagiation from "@/components/Pagiation.vue";
import ChooseLand from "./ChooseLand/Index";
import {
  getBaseInfo,
  getDetailInfo,
  getMissionInfo,
} from "@/api/request/snkd.njDispatch";
import { Nj_STATUS_TABS } from "@/confing";
import { dateFormat, setImgUrl } from "@/utils";
export default {
  components: {
    MainLayout,
    Pagiation,
    ChooseLand,
  },
  filters: {
    orderFormTime_filter(e, type = "yyyy-MM-dd hh:mm") {
      return e && dateFormat(e, type);
    },
    plateNumber_filter(e) {
      return e ? `(${e})` : "";
    },
  },
  data() {
    return {
      loading: true,
      tabs: Nj_STATUS_TABS,
      formInline: {
        pageNo: 1,
        pageSize: 20,
      },
      pagisShow: false,
      baseInfo: {},
      scoreInfo: {},
      list: [],
      manipulatorList: [],
      total: 0,
      orderId: null,
      tableLoading: true,
    };
  },
  async created() {
    this.orderId = this.$route.query.id;
    this.initPage();
  },
  methods: {
    setImgUrl,
    dealStataus(status) {
      return this.tabs.find((item) => item.value === status);
    },
    goBack() {
      this.$router.go(-1);
    },
    async initPage() {
      await this.getBaseInfoService();
      if (String(this.baseInfo.status) === String(this.tabs[4].value)) {
        this.getScoreInfoService();
      }
      await this.getMissionInfoService();
      this.loading = false;
    },
    async getMissionInfoService() {
      this.list = [];
      const { obj } = await getMissionInfo({
        orderId: this.orderId,
        pageNo: this.formInline.pageNo,
        pageSize: this.formInline.pageSize,
      });
      this.list = obj.list || [];
      this.total = obj.totalCount || 0;
      this.tableLoading = false;
      if (obj.totalCount > 20) {
        this.pagisShow = true;
      }
    },
    async getBaseInfoService() {
      const { obj } = await getBaseInfo({
        orderId: this.orderId,
      });
      this.baseInfo = obj;
      obj.manipulatorList.forEach((item) => {
        this.manipulatorList.push(item.intentionManipulatorName);
      });
    },
    async getScoreInfoService() {
      const { obj } = await getDetailInfo({
        orderId: this.orderId,
      });
      this.scoreInfo = obj || {};
    },
    currentChange(pageNo) {
      this.formInline.pageNo = pageNo;
      this.tableLoading = true;
      this.getMissionInfoService();
    },
  },
};
</script>
<style scoped lang="scss">
.main-content {
  width: 1200px;
  min-height: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 18px 0;
  .common {
    padding: 20px;
    background-color: #fff;
    margin-bottom: 18px;
    border-radius: 8px;
    .header {
      color: #333;
      font-size: 16px;
      font-weight: 600;
      padding-bottom: 18px;
      border-bottom: 1px solid #e5e5e5;
    }
    .spic {
      margin-bottom: 24px;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      padding-top: 20px;
      font-size: 14px;
      .li-item {
        width: 50%;
        color: #999;
        margin-bottom: 16px;
        line-height: 20px;
        > :nth-child(1) {
          color: #333;
        }
      }
      .map {
        width: 100%;
        height: 320px;
      }

      .njs-content {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 16px;
        padding: 18px;
        background: #f7f9fb;
        .njs-item {
          width: 50%;
          margin-bottom: 16px;
          line-height: 20px;
          color: #999;
          > :nth-child(1) {
            color: #333;
          }
          .label {
            margin: 0 6px;
          }
        }
      }
      .notimg {
        padding-bottom: 0;
      }
    }
  }
}
.imgs {
  width: 100%;
  display: flex;
  .img-li {
    width: 80px;
    height: 80px;
    margin-right: 12px;
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.spic-item {
  display: flex;
  align-items: center;
}
.rate {
  display: inline-block;

  ::v-deep .el-rate__icon {
    font-size: 22px !important;
  }
}
::v-deep .el-table {
  td,
  th {
    border-bottom: none !important;
  }
  thead {
    th {
      background: #f7f9fb !important;
    }
  }
  .el-table__row--striped td {
    background: #f7f9fb !important;
  }
  &::before {
    height: 0 !important;
  }
}
::v-deep {
  .mode-wrapper {
    height: 100%;
  }
}
</style>
